/* eslint-disable */
import Add16 from '@carbon/icons-react/es/add/16';
import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as End } from 'assets/svgs/end.svg';
import { EmptyState } from 'components/atoms/empty-state';
import { useTranslation } from 'hooks/use-translation';

const Container = styled.div`
  margin-bottom: 300px;
`;

export const EmptyStateDemo = () => {
  return (
    <>
      <Space direction="vertical" size={300}>
        <EmptyState
          image={<End />}
          title="Main title"
          message="This body copy explains the empty state and directs the user to the UI element to click. The icon relates to the situation."
          primaryCTA={
            <EmptyState.CallToAction.Primary icon={<Add16 />}>
              Primary Action
            </EmptyState.CallToAction.Primary>
          }
          secondaryCTA={
            <EmptyState.CallToAction.Secondary>
              Secondary Call to Action
            </EmptyState.CallToAction.Secondary>
          }
        />

        <EmptyState
          size="large"
          image={<End />}
          title="Your tasks will appear here."
          message="This body copy explains the empty state and directs the user to the UI element to click. The icon relates to the situation."
          primaryCTA={
            <EmptyState.CallToAction.Primary icon={<Add16 />}>
              {useTranslation('projects.create.title')}
            </EmptyState.CallToAction.Primary>
          }
          secondaryCTA={
            <EmptyState.CallToAction.Secondary>
              {useTranslation('projects.create.title')}
            </EmptyState.CallToAction.Secondary>
          }
        />
      </Space>
      <Container>
        <EmptyState
          direction="horizontal"
          align="start"
          image={<End />}
          title="Your tasks will appear here."
          message="This body copy explains the empty state"
          secondaryCTA={
            <EmptyState.CallToAction.Secondary>
              {useTranslation('projects.create.title')}
            </EmptyState.CallToAction.Secondary>
          }
        />
      </Container>
      <Container>
        <EmptyState
          direction="horizontal"
          align="start"
          size="large"
          image={<End />}
          title="Your tasks will appear here."
          message="This body copy explains the empty state and directs the user to the UI element to click. The icon relates to the situation."
          primaryCTA={
            <EmptyState.CallToAction.Primary icon={<Add16 />}>
              {useTranslation('projects.create.title')}
            </EmptyState.CallToAction.Primary>
          }
          secondaryCTA={
            <EmptyState.CallToAction.Secondary>
              {useTranslation('projects.create.title')}
            </EmptyState.CallToAction.Secondary>
          }
        />
      </Container>
    </>
  );
};
